// import apigestao from "axios"
import apigestao from "../apigestao"

import { SEARCH_CUPOM, VALUE_CUPOM, TOTAL_CREDIT, EXCHANGE_HEADER, REGISTER_CREDIT, GET_ALL_EXCHANGE, VIEW_EXCHANGE, ERROR_DIALOG, AUTOCOMPLETE_EXCHANGE, CANCEL_EXCHANGE, GET_ALL_TAX_OPERATION_TYPE } from "./actions/exchange_control"

export default {
    state: {
        cupomInformation: Object(),
        cuponValue: Number(),
        totalCredit: Number(),
        exchangeHeader: Object(),
        creditRegistered: Object(),
        exchangeItems: Object(),
        exchangeToAdd: Object(),
        viewExchange: Object(),
        errorDialog: Boolean(false),
    },
    getters: {
        getCupomInformation: (store) => store.cupomInformation,
        getCuponValue: (store) => store.cuponValue,
        getTotalCredit: (store) => store.totalCredit,
        getExchangeHeader: (store) => store.exchangeHeader,
        getCreditRegistered: (store) => store.creditRegistered,
        getExchangeItems: (store) => store.exchangeItems,
        getExchangeToAdd: (store) => store.exchangeToAdd,
        getViewExchange: (store) => store.viewExchange,
        getErrorDialog: (store) => store.errorDialog,
    },
    mutations: {
        EXCHANGE_HEADER: function (store, payload) {
            const exchangeHeader = {
                exchangeHeader: payload,
                billsToPayInformation: store.cupomInformation
            }
            store.exchangeHeader = exchangeHeader
        },
        VALUE_CUPOM: function (store, payload) {
            store.cuponValue = payload
        },
        TOTAL_CREDIT: function (store, payload) {
            store.totalCredit = payload
        },
        REGISTER_CREDIT: function (store, payload) {
            store.exchangeToAdd = payload
        },
        GET_ALL_EXCHANGE: function (store, payload) {
            store.exchangeItems = payload
        },
        SEARCH_CUPOM: function (store, payload) {
            store.cupomInformation = { ...payload }
        },
        VIEW_EXCHANGE: function (store, payload) {
            store.viewExchange = payload
        },
        ERROR_DIALOG: function (store, payload) {
            store.errorDialog = !store.errorDialog
        }
    },
    actions: {
        EXCHANGE_HEADER: function (context, payload) {
            context.commit(EXCHANGE_HEADER, payload)
        },
        TOTAL_CREDIT: function (context, payload) {
            context.commit(TOTAL_CREDIT, payload)
        },
        VALUE_CUPOM: function (context, payload) {
            context.commit(VALUE_CUPOM, payload)
        },
        GET_ALL_EXCHANGE: async function (context, payload) {
            let token = localStorage.getItem("token_gestao");
            try {
                const response = await apigestao.post("/exchange/index", payload,{ headers: {
                    'Authorization': 'Bearer ' + token,
          
                  }})

                context.commit(GET_ALL_EXCHANGE, response)
                
                return response
            } catch (error) {
                throw new Error(error)
            }
        },
        REGISTER_CREDIT: async function (context, payload) {
            let token = localStorage.getItem("token_gestao");
            try {
                const response = await apigestao.post("/exchange/store", payload, { headers: {
                    'Authorization': 'Bearer ' + token,
          
                  }})
                context.commit(REGISTER_CREDIT, response)
                return response
            } catch (error) {
                return new Error(error)
            }

        },
        SEARCH_CUPOM: async function (context, payload) {
            let token = localStorage.getItem("token_gestao");
            try {
                const response = await apigestao.get("/sales/getbynumbersale", { params: payload }, { headers: {
                    'Authorization': 'Bearer ' + token,
                }});
                context.commit(SEARCH_CUPOM, response.data);
                return response.data;
            } catch (error) {
                context.commit(ERROR_DIALOG, error)
            }
        },
        VIEW_EXCHANGE: function (context, payload) {
            context.commit(VIEW_EXCHANGE, payload)
        },
        AUTOCOMPLETE_EXCHANGE: async function (context, payload) {
            let token = localStorage.getItem("token_gestao");
            try {
                const response = await apigestao.post("/exchange/autocomplete", payload,{ headers: {
                    'Authorization': 'Bearer ' + token,
                }})
                
                return response
            } catch (error) {
                throw new Error(error)
            }
        },
        CANCEL_EXCHANGE: async function (context, payload) {
            let token = localStorage.getItem("token_gestao");
            try {
                const response = await apigestao.post("", payload,{ headers: {
                    'Authorization': 'Bearer ' + token,
                }})
                
                return response
            } catch (error) {
                throw new Error(error)
            }
        },

        async GET_ALL_TAX_OPERATION_TYPE({ commit }, payload) {
            let token = localStorage.getItem("token_gestao");
            try {
              const response = await apigestao
                .post("taxOperationType/index", payload,{ headers: {
                    'Authorization': 'Bearer ' + token,
                }})
      
                commit(GET_ALL_TAX_OPERATION_TYPE, response.data[0]);
      
                return response.data[0];
      
            } catch (error) {
              throw new Error(error)
            }
          },
    },
}